import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { BaseListApiService } from '@common/api/base-list-api.service';
import { ResultApi } from '@common/api/result-api';
import { VboRepoApi } from '../../models/vbo-repo-api';

@Injectable({
    providedIn: 'root'
})
export class VboCapacityListApiService extends BaseListApiService<VboRepoApi>
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.resourceUrl = '/hist/vbo/latest/repos';
    }

    getLastRepo (range: string): Observable<ResultApi<VboRepoApi>>
    {
        return this.getAll(`${this.resourceUrl}?${range}`);
    }
}
